/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import {
  useEffect,
  useState,
  createRef,
  useCallback,
  useContext,
  useMemo,
} from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription } from "@repo/ui";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { getter, process } from "@progress/kendo-data-query";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PATHS } from "routes/paths";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { FiltersContext } from "store/filters-context";
import { useUser } from "hooks/use-user";
import {
  useGetPanicAlertIncidentAssignedRequests,
  useExportPanicAlertIncidentAssignedRequests,
  usePanicAlertIncidentBulkAssign,
} from "services/panic-alert";
import { StatusContext } from "../constants";
import {
  fixKendoGridContent,
  getTicketDetailsPage,
  isFilterUpdated,
} from "../utils";
import GridDataCopyCell from "components/copy";
import CSMonitoringTaskFilterBarV2 from "components/tickets/cs-monitoring-task-filter-bar";

export default function CSMonitoringAssignedTicketsList() {
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  });
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedState, setSelectedState] = useState({});
  const { filters } = useContext(FiltersContext);
  const [localFilters, setLocalFilters] = useState({
    searchCriteria: filters?.searchCriteria?.value || "",
    period: filters?.period?.value || "All",
    cashCenterId: filters?.cashCenterId?.value || "",
    customerId: filters?.customerId?.value || "",
    assignmentGroup: filters?.assignmentGroup?.value || "",
    assetId: filters?.assetId?.value || "",
    activityType: filters?.activityType?.value || "",
    routeNo: filters?.routeNo?.value || "",
    assignedTo: filters?.assignedTo?.value || "",
  });
  const { setStatus } = useContext(StatusContext);

  const user = useUser();
  const pageSize = 100;
  const _exporter = createRef();
  const DATA_ITEM_KEY = "requestId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetPanicAlertIncidentAssignedRequests();

  const {
    mutate: getAllTickets,
    data: allTicketsData,
    isPending: gettingAllTickets,
    reset: getAllTicketsReset,
  } = useExportPanicAlertIncidentAssignedRequests();

  const {
    mutate: bulkAssign,
    data: bulkAssignRes,
    isPending: bulkAssigning,
    error: bulkAssignError,
    reset: bulkAssignReset,
  } = usePanicAlertIncidentBulkAssign();

  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  useEffect(() => {
    if (allTicketsData) {
      excelExport();
      getAllTicketsReset();
    }
    if (bulkAssignRes) {
      bulkAssignReset();
      onRefresh();
    }
    if (bulkAssignError) {
      bulkAssignReset();
    }
  }, [allTicketsData, bulkAssignRes, bulkAssignError]);

  useEffect(() => {
    const nextFilters = {
      searchCriteria: filters?.searchCriteria?.value || "",
      period: filters?.period?.value || "All",
      cashCenterId: filters?.cashCenterId?.value || "",
      customerId: filters?.customerId?.value || "",
      assignmentGroup: filters?.assignmentGroup?.value || "",
      assetId: filters?.assetId?.value || "",
      activityType: filters?.activityType?.value || "",
      routeNo: filters?.routeNo?.value || "",
      assignedTo: filters?.assignedTo?.value || "",
    };

    if (isFilterUpdated(localFilters, nextFilters)) {
      setLocalFilters({ ...nextFilters });
    }
  }, [filters]);
  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...localFilters,
    });
  }, [localFilters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(
        ticketsList.data.data.map((elm) => ({
          ...elm,
          expanded: false,
          selected: false,
        }))
      );
      resetGetTickets();
    }
  }, [ticketsList]);

  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };
  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const onSelectionChange = useCallback(
    (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });

      setSelectedState(newSelectedState);
    },
    [selectedState]
  );

  const onHeaderSelectionChange = useCallback((event) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    if (checked) {
      event.dataItems.forEach((item) => {
        newSelectedState[idGetter(item)] = checked;
      });
    }
    setSelectedState(newSelectedState);
  }, []);

  const onBulkAssign = (information) => {
    const selectedItems = [];
    Object.keys(selectedState).forEach((elm) => {
      if (selectedState[elm]) {
        selectedItems.push(elm);
      }
    });
    const payload = {
      cashCenterId: user.CashCenterId,
      operationDate: new Date(),
      assignedByUserId: user.UserId,
      assignedToUserId: information.assigneeId,
      requests: selectedItems.map((elm) => ({
        requestId: elm,
      })),
    };
    bulkAssign(payload);
    setSelectedState({});
  };

  const getSelectedRequests = useMemo(() => {
    return tickets.filter((elm) => selectedState[elm.requestId]);
  }, [selectedState]);

  return (
    <div className="box-border">
      {gettingTickets || bulkAssigning ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[{ text: "Dashboard", to: "/" }, { text: "Assigned Tickets" }]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <CSMonitoringTaskFilterBarV2
              hideStatus
              exportExcel
              bulkUpload
              onRefresh={onRefresh}
              exportingExcel={gettingAllTickets}
              selectedRequests={getSelectedRequests}
              assignTeam={onBulkAssign}
              onExcelExport={() => {
                getAllTickets({
                  status: "All",
                  ...localFilters,
                });
              }}
            />
          </CardDescription>

          <Grid
            data={process(
              tickets.map((item) => ({
                ...item,
                [SELECTED_FIELD]: selectedState[idGetter(item)],
              })),
              dataState
            )}
            {...dataState}
            onDataStateChange={(e) => {
              e.dataState.skip = 0;
              setDataState(e.dataState);
            }}
            className="list-tables-v1"
            width="100%"
            filterable
            sortable
            pageable
            navigatable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            onPageChange={onPageChange}
            selectable={{
              enabled: true,
              drag: true,
              cell: false,
              mode: "multiple",
            }}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              field={SELECTED_FIELD}
              width="50px"
              filterable={false}
              headerSelectionValue={
                tickets.findIndex((item) => !selectedState[idGetter(item)]) ===
                -1
              }
            />

            <GridColumn
              title="Ticket Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("CSMonitoringAssigned");
                          }}
                          to={`${PATHS.panicAlertDetails}/${dataItem.ticketId}`}
                        >
                          {dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />
            <GridColumn
              title="Task Number"
              width="170px"
              field="taskNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("CSMonitoringAssigned");
                          }}
                          to={`${PATHS.panicAlertTaskDetails}/${dataItem.requestId}`}
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.taskNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />
            <GridColumn title="Asset Id" field="registrationNo" width="150px" />
            <GridColumn title="Region" field="officeState" width="150px" />

            <GridColumn title="Location" field="officeName" width="170px" />

            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Assigned To" field="assigneeId" width="150px" />

            <GridColumn
              title="Open At"
              field="createdDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Start At"
              field="startedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="State"
              field="status"
              width="100px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn title="Account" field="customer" width="170px" />

            <GridColumn title="Description" field="remarks" width="400px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />
          </Grid>
          <ExcelExport
            data={allTicketsData?.data.data || []}
            fileName="Tickets.xlsx"
            ref={_exporter}
          >
            <GridColumn title="Ticket Number" field="caseNo" />
            <GridColumn title="Task Number" field="taskNo" />
            <GridColumn title="Asset Id" field="registrationNo" width="150px" />
            <GridColumn title="Region" field="officeState" width="150px" />

            <GridColumn title="Location" field="officeName" width="170px" />

            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Assigned To" field="assigneeId" />

            <GridColumn title="Open At" field="createdDateTime" width="120px" />
            <GridColumn title="State" field="status" width="100px" />
            <GridColumn title="Account" field="customer" width="170px" />

            <GridColumn title="Description" field="remarks" width="170px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />
            <GridColumn title="Opened By" field="openedBy" width="170px" />
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
